import { useBCMSModal } from "@bcm-dev/bcms-vite";
import CustomModal, { CustomModalContent, CustomModalFooter, ModalCloseButton, ModalPrimaryButton } from 'compid/custom-ui/CustomModal';
import React from 'react';
import { SVGAsset } from 'res';
import './styles.css';

/**
 * @function InsufficientFundsModal
 * @param {Object} data - A js object with props "payAmount", "payFrom" and "onModalPayButtonClick".
 * "payAmount" - instance of BCMSCurrency. 
 * "payFrom" - instance of Account.
 * "onModalPayButtonClick" - callback function for the "Pay..." button in the modal.
 * @return {React.Component}
 * @exported true
 * @description The modal that shows when there are insufficient funds
 */
export default function InsufficientFundsModal(props) {
  const { close } = useBCMSModal();
  const data = props.data ?? {};
  const payAmount = data.payAmount ?? {};
  const payFromAccount = data.payFrom ?? {};
  
  // Not currently used.
  const onPayClick = () => {
    if(props.data.onModalPayButtonClick) props.data.onModalPayButtonClick();
    close("InsufficientFundsModal");
  }

  return(
    <CustomModal id="InsufficientFundsModal" className="insufficient-funds-modal large-icon-modal">
    <CustomModalContent className="flex-container flex-horizontal align-top">
      <div className="set-width">
        <SVGAsset id="AlertTriangleIcon" className="alert-icon left-icon" />
      </div>
      <div className="flex-width">
        <h4 className="modal-title"><b>Insufficient Funds</b></h4>
        <p className="sub-text">{ `The payment is scheduled to be withdrawn today, but you currently do not have enough funds in account ${ payFromAccount.number }. Would you like to proceed with this payment?` }</p>
      </div>
    </CustomModalContent>
    <CustomModalFooter className="form-button-container button-container flex-container flex-horizontal align-center">
      <ModalCloseButton text="Cancel" id="InsufficientFundsModal" />
      <ModalPrimaryButton text={ `Pay ${ payAmount.format() }` } onClick={ onPayClick } />
    </CustomModalFooter>
  </CustomModal>
  );
}